export function formatDate(value?: string | null): string {
  if (!value) return 'غير متاح';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return 'غير متاح';
  return new Intl.DateTimeFormat('ar-SA', {
    timeZone: 'Asia/Riyadh',
    dateStyle: 'medium',
    timeStyle: 'short'
  }).format(date);
}

export function formatDuration(milliseconds = 0): string {
  const seconds = Math.max(0, Math.floor(milliseconds / 1000));
  const minutesPart = Math.floor(seconds / 60).toString().padStart(2, '0');
  const secondsPart = (seconds % 60).toString().padStart(2, '0');
  return `${minutesPart}:${secondsPart}`;
}

export function formatBytes(bytes = 0): string {
  if (bytes < 1024) return `${bytes} بايت`;
  if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(1)} ك.ب`;
  if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(1)} م.ب`;
  return `${(bytes / 1024 ** 3).toFixed(1)} ج.ب`;
}

export function createClientId(): string {
  return crypto.randomUUID();
}
